module.exports = __webpack_public_path__ + "img/yxl_common.96357bd8.png";